// extracted by mini-css-extract-plugin
module.exports = {"cf7zkrq":"cf7zkrq","cq6sr43":"cq6sr43"};